export const defaultPipSize = 0.0001;
